
  import Vue from 'vue'
import { extractErrorMessage } from '@/utils/Util';
import TagService from '@/services/TagService';

  export default Vue.extend({
    name: 'TagDeleteDialog',
    props: ['tag'],
    data: () => ({
        localDialog: false,
        alertText: "",
        alertVisible: false,
        alertType: "error",
        loading: false,
    }),
    methods: {
      close() {
        this.localDialog = false;
      },
      clear() {
        this.alertVisible = false;
        this.loading = false;
      },
      dismiss() {
        this.clear();
        this.close();
      },
      confirmDelete() {
        this.loading = true;
      
        TagService.delete(this.$root.$store.state.session.selectedTenant.uuid, this.tag.uuid).then(() => {
            this.alertType = "success";
            this.alertText = this.$t('tag.successDelete') as string;
            this.alertVisible = true;
            this.loading = false;

            setTimeout(() => { 
                this.$emit("delete", this.tag);
                this.dismiss(); 
            }, 2000);
        }).catch((err) => {
            console.log(err);
            console.log(err.response);
            this.alertType = "error";
            this.alertText = this.$t('tag.errorDelete') + ' ' + extractErrorMessage(err);
            this.alertVisible = true; 
            this.loading = false;
        });
      }
    }
  })
